module.exports = __webpack_public_path__ + "static/img/9.64c7658.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/9.png
// module id = IGux
// module chunks = 0